import { render, staticRenderFns } from "./transactionModeManage.vue?vue&type=template&id=5c33671b&scoped=true"
import script from "./transactionModeManage.vue?vue&type=script&lang=js"
export * from "./transactionModeManage.vue?vue&type=script&lang=js"
import style0 from "./transactionModeManage.vue?vue&type=style&index=0&id=5c33671b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c33671b",
  null
  
)

export default component.exports